import { render, staticRenderFns } from "./comentario.vue?vue&type=template&id=c674c09a&scoped=true"
import script from "./comentario.vue?vue&type=script&lang=js"
export * from "./comentario.vue?vue&type=script&lang=js"
import style0 from "./comentario.vue?vue&type=style&index=0&id=c674c09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c674c09a",
  null
  
)

export default component.exports